import assetUtils from 'app-lib/assetUtils'
import { formatPercent } from 'app-lib/numberUtils'
import { chainConfigs, routes } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { Icon, Loader, useElementSizeQuery } from 'ui-framework'
import DashboardVM from '../DashboardVM'

const loader = (
  <div className="flex-center">
    <Loader quantityDots={3} sizeDots="small" />
  </div>
)

const mediaQueries: { minWidth: [number, string][] } = {
  minWidth: [[320, 'lobby__apr-icons-visible']],
}

export function BestAPR({ vm }: { vm: DashboardVM }) {
  const { statsStore } = vm.rootStore
  const hasAPR = statsStore.bestLendAprs.some((apr) => apr.tokens.length > 0)
  const [media, setRef] = useElementSizeQuery(mediaQueries)

  return (
    <div className={`panel--simple flex-col ${media.minWidth}`} ref={setRef}>
      <h3 className="lobby__widget-header title-section padded-1 flex-row-center justify-between">
        Best Rates
        <NavLink to={routes.lend} className="btn btn--blue btn--medium flex-row-end">
          Lend Now
        </NavLink>
      </h3>

      {!statsStore.stats.loaded && !statsStore.stats.error && loader}

      {statsStore.stats.error && (
        <p className="txt-warning padded-1">The best lending APR could not be fetched.</p>
      )}

      {hasAPR && (
        <div className="overflow-y-auto">
          {statsStore.bestLendAprs.map(({ chainId, tokens }, index) => {
            const { shortName: chainName } = chainConfigs[chainId].chainDetails
            const chainIcon = chainConfigs[chainId].icon
            return (
              <div className="padded-h-1" key={chainId}>
                <div className="margin-bottom-05">
                  <Icon name={chainIcon.name} color={chainIcon.color} size={24} />
                  <b className="margin-left-1ch">{chainName}</b>
                  {index === 0 && <span className="margin-left-05 txt-size-12">🚀</span>}
                </div>

                <div className="lobby__apr-grid margin-bottom-2">
                  {tokens.slice(0, 3).map((token) => {
                    const { spriteLogo } = assetUtils.getCommon(token.tokenName)
                    return (
                      <div key={token.tokenName} className="flex-row-center">
                        <div>
                          <div className="txt-muted">{token.tokenName}</div>
                          <b className="lobby__apr-percent">{formatPercent(token.supplyApr)}%</b>
                        </div>
                        <Icon name={spriteLogo} className="lobby__apr-token-icon" size={30} />
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default observer(BestAPR)
